module.exports = __webpack_public_path__ + "img/Weilin PC terminal equipment monitoring software.d9ffc24b.jpg";